import React, { useCallback } from "react";
import { destroyPracticeTeamParticipant } from "../../apis/destroyPracticeTeamParticipant";
import { usePracticeTeam } from "../../contexts/practice-team-context";
import Participants from "../participants";
import { participantTypes } from "../../constants";
import { translate } from "@td/shared_utils";
import toastr from "toastr";

const ParticipantsList = ({ participants = [] }) => {
  const { loadPracticeTeam } = usePracticeTeam();

  const handleDelete = useCallback(async (practiceTeamParticipantId) => {
    const isConfirmed = confirm(
      translate(null, "practice_team.participants.deletion", "confirmation")
    );

    if (!isConfirmed) {
      return;
    };

    const { success } = await destroyPracticeTeamParticipant(practiceTeamParticipantId);

    if (success) {
      toastr.success(
        translate(null, "practice_team.participants.deletion", "notification")
      );

      loadPracticeTeam();
    } else {
      toastr.error(
        translate(null, "practice_team", "server_error")
      );
    }
  });

  return (
    <div className="section">
      <Participants
        title={translate(null, "practice_team.participants.headers", "care_team")}
        participants={participants}
        participantType={participantTypes.ADMIN}
        onDelete={handleDelete}
      />
      <Participants
        title={translate(null, "practice_team.participants.headers", "providers")}
        participants={participants}
        participantType={participantTypes.PROVIDER}
      />
    </div>
  );
};

export default ParticipantsList;
